import {isEligible} from '@wix/ambassador-premium-features-manager-v1-feature/http'
import {IHttpClient} from '@wix/yoshi-flow-editor'
import {ErrorHandlerPublicAPI} from '@wix/yoshi-flow-editor/build/cjs/exports/error-handler'

export const getIsSiteBusinessPremium = async ({
  httpClient,
  errorHandler,
}: {
  httpClient: IHttpClient
  errorHandler: ErrorHandlerPublicAPI
}) => {
  const {data} = await errorHandler.withErrorHandler(
    () => httpClient.request(isEligible({uniqueName: 'restaurants_table_reservations'})),
    {
      errorCodesMap: {},
    },
  )

  return data.isEligible ?? false
}
